module.exports = __webpack_public_path__ + "img/恒顺集团LOGO.fab225d0.png";